function EnrolleeAlternateContact(){
    this.__type = 'EnrolleeAlternateContact:www.veritracks.com';
    this.Id = -1;
    this.Name = '';
    this.Phone = '';
    this.Email = '';
}